/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateQuoteRequestPost } from '../../models/create-quote-request-post';
import { CreateQuoteResponse } from '../../models/create-quote-response';

export interface QuotesControllerCreateQuote$Params {

/**
 * Language code of the application performing API request.
 */
  'x-ca-application-lang-code'?: 'cs' | 'de' | 'en' | 'es' | 'fr' | 'nl' | 'pl' | 'sk';

/**
 * A header used for security reasons. Header is automatically sent by browsers. When using the code-to-API solution (calling this API directly by script code or other API) please contact <strong>Customer Apps</strong> team for more details.
 */
  referer?: string;

/**
 * Authentication token from Viessmann IAM OAuth2. Required for VIESSMANN_IAM authentication.
 */
  authorization?: string;

/**
 * Application ID identifying the client application. Required for VIESSMANN_IAM authentication.
 */
  'x-application-id'?: 'HEAT_PUMP_PLANNER' | 'PHOTOVOLTAIC_PLANNER' | 'VENTILATION_PLANNER' | 'VIGUIDE_PLANNING' | 'HOME_PLANNER' | 'BOILER_PLANNER' | 'SALESFORCE' | 'CONFIGURATION_PORTAL';

/**
 * Country code of the client application instance. Required for VIESSMANN_IAM authentication.
 */
  'x-application-country-code'?: 'AT' | 'BE' | 'CH' | 'CZ' | 'DE' | 'ES' | 'FR' | 'NL' | 'PL' | 'SK' | 'LU';
      body: CreateQuoteRequestPost
}

export function quotesControllerCreateQuote(http: HttpClient, rootUrl: string, params: QuotesControllerCreateQuote$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateQuoteResponse>> {
  const rb = new RequestBuilder(rootUrl, quotesControllerCreateQuote.PATH, 'post');
  if (params) {
    rb.header('x-ca-application-lang-code', params['x-ca-application-lang-code'], {});
    rb.header('referer', params.referer, {});
    rb.header('authorization', params.authorization, {});
    rb.header('x-application-id', params['x-application-id'], {});
    rb.header('x-application-country-code', params['x-application-country-code'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateQuoteResponse>;
    })
  );
}

quotesControllerCreateQuote.PATH = '/planning-projects/v1-preview/quotes';
